import React, { Component } from "react";
import { connect } from "react-redux";

import { SET_ARTICLE_LIST } from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import HelpList from "./HelpList";
import HelpAndSupportFooter from "../CommonComponents/HelpAndSupportFooter";
import ErrorMessage from "../CommonComponents/ErrorMessage";

import api from "../../api/api";

/**
 * this class contains the page of list of articles in a section
 */
class HelpTopicList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curr_page: this.props.articlesListData.curr_page,
      newSection: true,
      scrolling: false,
      displayErrorPopup: false
    };
  }

  /**
   * this is for history or goback
   */
  goBack = () => {
    if (this.props.history && this.props.history.length > 1) {
      this.props.history.goBack();
    } else {
      window.open("/faqclose", "_self");
    }
  };

  /**
   * call zendesk api to get faq and the list of help tickets
   * it send the data to the store using setArticleData dispatcher
   */
  loadArticles() {
    if (this.state.curr_page >= 0) {
      api
        .articlesInSections(this.props.match.params.id, this.state.curr_page)
        .then(data => {
          let dataToSet = {
            articlesListArray: this.props.articlesListData.articlesListArray.concat(data.data),
            page_count: data.data.page_count,
            curr_page: data.data.page,
            sectionsNumber: this.props.match.params.id
          };
          this.props.setArticleData(dataToSet);
          this.setState(
            {
              newSection: false,
              curr_page: data.data.curr_page,
              scrolling: false
            },
            () => {
              api.displayHideLoader();
            }
          );
        })
        .catch(error => {
          this.setState({
            displayErrorPopup: true,
            scrolling: false
          });
          api.displayHideLoader();
          console.log(error);
        });
    }
  }

  /**
   * this is called when the page is scrolled and it has next page
   * and it sets the condition to scrolling true so that we didn't do same api call for more that one time
   */
  loadMoreArticles = () => {
    this.setState(
      {
        curr_page: this.state.curr_page + 1,
        scrolling: true
      },
      () => {
        this.loadArticles();
      }
    );
  };

  /**
   * it is called when page is scrolled
   * if page is at the second last card then it checks that is there next page or not
   * if next page it there it calls loadMoreArticles
   * else it returns out of the loop
   */
  handleScroll = () => {
    const scrolling = this.state.scrolling;
    const totalPage = this.props.articlesListData.page_count;
    const page = this.props.articlesListData.curr_page;

    if (scrolling) {
      return;
    }

    if (totalPage <= page) {
      return;
    }

    const secondLastElement = document.querySelector(".help-support-card-container:nth-last-child(2)");
    const lastOffset = secondLastElement ? secondLastElement.offsetTop + secondLastElement.clientHeight : 0;
    const pageOffset = window.pageYOffset + window.innerHeight;
    const bottomOffset = 50;
    if (pageOffset > lastOffset - bottomOffset) {
      this.loadMoreArticles();
    }
  };

  /**
   * to hide the displayed error message
   */
  errorCloseCLick = () => {
    this.setState({
      displayErrorPopup: false
    });
  };

  /**
   * if the store has the data for the same section the is displayes the data else it does the api calls
   */
  componentDidMount() {
    api.displayHideLoader();
    if (
      this.props.articlesListData.articlesListArray.length === 0 ||
      this.props.articlesListData.sectionsNumber !== this.props.match.params.id
    ) {
      api.displayMainLoader();
      this.setState(
        {
          curr_page: 1
        },
        () => {
          this.loadArticles();
        }
      );
    } else {
      this.setState({
        newSection: false
      });
    }
    this.scrollListner = window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  render() {
    console.log(this.props);
    return (
      <div>
        {this.state.displayErrorPopup ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} /> : ""}
        <HelpAndSupportHeader displayMessage={this.props.headerMessage} back={this.goBack.bind(this)} />
        <div className="body-container">
          <div className="help-topic-container">
            {this.state.newSection
              ? ""
              : this.props.articlesListData.articlesListArray.map(singleVal => {
                  return singleVal.draft ? null : <HelpList key={singleVal.id} displayData={singleVal} />;
                })}
          </div>
        </div>
        <HelpAndSupportFooter />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    headerMessage: {
      title: state.headerTitle,
      description: state.headerDescription,
      backIcon: true,
      moreOptionhidden: true,
      searchOptionHidden: false
    },
    articlesListData: state.articlesListData
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setArticleData: articleList => {
      dispatch({
        type: SET_ARTICLE_LIST,
        payload: articleList
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HelpTopicList);



// WEBPACK FOOTER //
// ./src/components/Articles/HelpTopicList.js